import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";

// Lightweight single-review strip to place near CTAs for social proof.
export const ProofStrip = ({ service }) => {
  const [review, setReview] = useState(null);
  const [exact, setExact] = useState(false);
  useEffect(() => {
    api.get("/testimonials").then(({ data }) => {
      if (!data?.length) return;
      const match = service ? data.find((r) => r.service === service) : null;
      setExact(Boolean(match));
      setReview(match || data[Math.floor(Math.random() * data.length)]);
    }).catch(() => {});
  }, [service]);
  if (!review) return null;
  // Only show the service label when it genuinely matches THIS page's service,
  // so a fallback testimonial is never mislabeled as belonging to another service.
  const attribution = [review.name, review.city, exact ? review.service : null].filter(Boolean).join(" · ");
  return (
    <div className="ascendia-card p-5" data-testid="proof-strip">
      <div className="flex gap-0.5 mb-2">{Array.from({ length: review.rating || 5 }).map((_, i) => <Star key={i} className="h-4 w-4 fill-gold text-gold" />)}</div>
      <p className="text-sm text-secondary">“{review.text}”</p>
      <p className="mt-2 text-xs text-muted-c">{attribution}</p>
    </div>
  );
};

export default ProofStrip;
